module.exports = __webpack_public_path__ + "img/login_bg_img.9d32a24a.png";